import { RouteConfig } from 'vue-router';
import { PermissionTypeEnum } from '../Api';
import ReportedIssueSolving from './pages/ReportedIssueSolving.vue';

export default [
    {
        path: '/:tenantId/reported-issue-solving',
        name: 'ReportedIssueSolving',
        component: ReportedIssueSolving,
        props: (route) => ({ tenantId: route.params.tenantId }),
        meta: {
            permissions: [PermissionTypeEnum.PerformAudit, PermissionTypeEnum.Response, PermissionTypeEnum.MistakeCorrection],
            checkLicence: true,
            title: 'menu.reportedIssueSolving',
        },
    },
] as RouteConfig[];
